import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AuthState, Token, Email } from 'features/auth/types'
import { PURGE } from 'redux-persist'
import type { RootState } from 'common/store/types'

const authSlice = createSlice({
  name: 'auth',
  initialState: { email: null, token: null, role: null, roleId: null, userId: null } as AuthState,
  reducers: {
    setCredentials: (
      state,
      {
        payload: { email, token, role, roleId, userId },
      }: PayloadAction<AuthState>,
    ) => {
      state.email = email
      state.token = token
      state.role = role
      state.roleId = roleId
      state.userId = userId
    },
    clearCredentials: (state) => {
      state.email = authSlice.getInitialState().email
      state.token = authSlice.getInitialState().token
      state.role = authSlice.getInitialState().role
      state.roleId = authSlice.getInitialState().roleId
      state.userId = authSlice.getInitialState().userId
    },
    setRegistration: (
      state,
      {
        payload: { email, code },
      }: PayloadAction<{ email: Email | null; code: string | null }>,
    ) => {
      state.email = email
      state.token = code
    },
  },
  extraReducers: (builder) => {
    builder.addCase(PURGE, (state) => {
      state.email = authSlice.getInitialState().email
      state.token = authSlice.getInitialState().token
      state.role = authSlice.getInitialState().role
      state.roleId = authSlice.getInitialState().roleId
      state.userId = authSlice.getInitialState().userId
    })
  },
})

export const { setCredentials, clearCredentials, setRegistration } =
  authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state: RootState) => state.auth
